import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

@Injectable({ providedIn: 'root' })
export class PaginatorIntlService extends MatPaginatorIntl {
  override itemsPerPageLabel = 'Items por página';
  override nextPageLabel = 'Página siguiente';
  override previousPageLabel = 'Página anterior';
  override firstPageLabel = 'Primera página';
  override lastPageLabel = 'Última página';

  override getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (length === 0 || pageSize === 0) {
      return `0 de ${length}`;
    }

    const totalLength = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex =
      startIndex < totalLength
        ? Math.min(startIndex + pageSize, totalLength)
        : startIndex + pageSize;

    return `${startIndex + 1} – ${endIndex} de ${totalLength}`;
  };
}
